exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-label-desc{font-size:14px;color:#666}", ""]);

// exports
